import React from "react";
import { Link } from "react-router-dom";
import { BUILDING, TEXTURES } from "@/data/content";

const FEATURED_SLUGS = ["kostaja", "revkontrol", "fundroute", "bristol-auto", "marshal-line", "young-subdivision"];

const IMAGES = {
  kostaja: TEXTURES.stairs,
  revkontrol: TEXTURES.buildingDetail,
  fundroute: TEXTURES.corridor,
  "bristol-auto": TEXTURES.emptyRoom,
  "marshal-line": TEXTURES.chairs,
  "young-subdivision": TEXTURES.stairs,
};

export const BuildingPreview = () => {
  const featured = FEATURED_SLUGS.map((slug) => BUILDING.find((b) => b.slug === slug)).filter(Boolean);

  return (
    <section data-testid="home-building-preview" className="bg-ink-base py-24 md:py-36 border-t border-ink-line">
      <div className="container-edge">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <p className="eyebrow-gold mb-5">Building</p>
            <h2 className="display-serif text-3xl md:text-5xl text-paper-primary text-balance">
              Evidence that ideas have been tested in reality.
            </h2>
          </div>
          <Link to="/building" className="btn-arrow self-start" data-testid="building-preview-all">
            <span>See the full slate</span>
            <span className="arrow">→</span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink-line">
          {featured.map((b, i) => (
            <Link
              key={b.slug}
              to={`/building/${b.slug}`}
              data-testid={`building-card-${b.slug}`}
              className="group relative bg-ink-base hover:bg-ink-surface transition-colors duration-500 p-8 md:p-10 min-h-[280px] flex flex-col justify-between overflow-hidden"
            >
              {/* Background texture - low opacity, desaturates on hover */}
              <div
                className="absolute inset-0 opacity-[0.08] grayscale group-hover:opacity-[0.18] group-hover:grayscale-[60%] transition-all duration-700"
                style={{
                  backgroundImage: `url(${IMAGES[b.slug]})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                aria-hidden="true"
              />
              <div className="relative">
                <div className="flex items-baseline justify-between gap-3">
                  <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">
                    {String(i + 1).padStart(2, "0")} · {b.category}
                  </p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-gold/70">{b.status}</p>
                </div>
                <h3 className="mt-6 font-serif text-3xl md:text-4xl text-paper-primary group-hover:text-gold-warm transition-colors duration-300">
                  {b.name}
                </h3>
                <p className="mt-4 text-paper-secondary text-sm md:text-base leading-relaxed font-sans">
                  {b.lead}
                </p>
              </div>

              <div className="relative mt-10 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.24em] text-paper-tertiary group-hover:text-paper-primary">
                <span>Open entry</span>
                <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuildingPreview;
